import { JSON_FORM, GO_TO_NEXT_JSON_TREE } from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleGoToNextJsonTree<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (state.type !== JSON_FORM || action.type !== GO_TO_NEXT_JSON_TREE) {
		return state
	}

	const getCurrentTree = state.questionTree.find(
		item => item.id === state.currentQuestionTreeId,
	)
	const childName = getCurrentTree?.tree.leadsToPhase ?? ''
	const childTree = state.questionTree.find(item => item.id === childName)?.tree
	const firstKey = Object.keys(childTree?.questions as any)[0]

	return {
		...state,
		currentQuestionTreeId: childTree?.id ?? '',
		currentQuestionId: firstKey,
	}
}
